import { axiosInstance } from '../client';

export interface LoginRequest {
  email: string;
  password: string;
}

export interface LoginResponse {
  access_token: string;
  token_type: string;
  expires_in: number;
  user: User;
}

export interface User {
  id: string;
  email: string;
  username: string;
  first_name: string;
  last_name: string;
  role: string;
  status: string;
  pin_enabled: boolean;
  created_at: string;
}

export interface RegisterRequest {
  email: string;
  username: string;
  password: string;
  first_name: string;
  last_name: string;
  phone?: string;
  role?: string;
}

export interface ChangePasswordRequest {
  old_password: string;
  new_password: string;
}

export const authService = {
  login: (data: LoginRequest) => axiosInstance.post<LoginResponse>('/api/v1/auth/login', data),
  register: (data: RegisterRequest) =>
    axiosInstance.post<LoginResponse>('/api/v1/auth/register', data),
  logout: () => axiosInstance.post('/api/v1/auth/logout'),
  refresh: () => axiosInstance.post('/api/v1/auth/refresh'),
  me: () => axiosInstance.get<User>('/api/v1/auth/me'),
  changePassword: (data: ChangePasswordRequest) => axiosInstance.put('/api/v1/auth/password', data),
  updateProfile: (data: { email: string; first_name: string; last_name: string; phone?: string }) =>
    axiosInstance.put<User>('/api/v1/auth/profile', data),
  setPin: (pin: string) => axiosInstance.post('/api/v1/auth/pin', { pin }),
  disablePin: () => axiosInstance.post('/api/v1/auth/pin/disable'),
  getPinStatus: () => axiosInstance.get<{ pin_enabled: boolean }>('/api/v1/auth/pin/status'),
  verifyPin: (pin: string) => axiosInstance.post('/api/v1/auth/verify-pin', { pin }),
  forgotPassword: (email: string) => axiosInstance.post('/api/v1/auth/forgot-password', { email }),
  setOwnerPassphrase: (passphrase: string) =>
    axiosInstance.post('/api/v1/auth/owner-passphrase', { passphrase }),
  verifyOwnerPassphrase: (passphrase: string) =>
    axiosInstance.post<{ token: string; token_type: string; expires_in: number }>(
      '/api/v1/auth/verify-owner-passphrase',
      { passphrase },
    ),
  checkOwnerPassphraseExists: () =>
    axiosInstance.get<{ exists: boolean }>('/api/v1/auth/owner-passphrase/exists'),
};
